<template>
  <div class="contain">
    <div class="layout-atten">
      <p class="name-clock-atten">{{salesName}}</p>
      <p class="info-clock-atten"><span class="color-gray">当前位置：</span>{{signCheckLocation.address}}<span v-show="signCheckLocation.address==''">{{locatingStr}}</span></p>
      <p class="info-clock-atten"><span class="color-gray">经度：</span>{{signCheckLocation.lng}}</p>
      <p class="info-clock-atten"><span class="color-gray">纬度：</span>{{signCheckLocation.lat}}</p>
      <p class="info-clock-atten"><span class="color-gray">定位方式：</span>{{signCheckLocation.type}}<span v-if="signCheckLocation.accuracy">（精度 {{signCheckLocation.accuracy}} 米）</span></p>
    </div>
    <!-- 当前位置地图 -->
    <!-- <div class="checkin-map" ref="mapEl"></div> -->
    <div class="btn-clock"
         @click="checkin"><span class="tit-clock">打卡</span><span class="time-clock">{{nowDate}}</span></div>
    <p class="rep-clock"
       @click="reLoaction">定位不准？重新定位</p>
  </div>
</template>

<script>
/* global qq */
import checkinModel from '../../../api/model/checkin'
import { mapState } from 'vuex'
export default {
  name: 'SignCheckin',
  data() {
    return {
      nowDate: '',
      address: '',
      dotNum: 0,
      locatingStr:'定位中请稍后',
      map: null, // 腾讯地图实例
      marker: null, // 当前位置标记
      infoWindow: null // 地址信息窗
    }
  },
  methods: {
    currentTime() {
      setInterval(this.formatDate, 500)
      setInterval(this.locating, 1000)
    },
    formatDate() {
      let date = new Date()
      let hour = date.getHours() // 时
      hour = hour < 10 ? '0' + hour : hour // 如果只有一位，则前面补零
      let minute = date.getMinutes() // 分
      minute = minute < 10 ? '0' + minute : minute // 如果只有一位，则前面补零
      let second = date.getSeconds() // 秒
      second = second < 10 ? '0' + second : second // 如果只有一位，则前面补零
      this.nowDate = `${hour}:${minute}:${second}`
    },
    // 在打卡界面上展示当前位置（腾讯地图）
    updateMap() {
      const lat = parseFloat(this.signCheckLocation.lat)
      const lng = parseFloat(this.signCheckLocation.lng)
      // 定位未完成或坐标为 0 时不渲染
      if (isNaN(lat) || isNaN(lng) || (lat === 0 && lng === 0)) return
      // 腾讯地图 SDK 未加载时不渲染
      if (!window.qq || !window.qq.maps || !window.qq.maps.Map) return

      const latLng = new qq.maps.LatLng(lat, lng)
      if (!this.map) {
        this.map = new qq.maps.Map(this.$refs.mapEl, {
          center: latLng,
          zoom: 16
        })
        this.marker = new qq.maps.Marker({
          position: latLng,
          map: this.map
        })
        this.infoWindow = new qq.maps.InfoWindow({
          map: this.map,
          position: latLng,
          content: this.signCheckLocation.address || '',
          enableCustomStyle: true
        })
      } else {
        this.map.setCenter(latLng)
        this.marker.setPosition(latLng)
        this.infoWindow.setPosition(latLng)
        this.infoWindow.setContent(this.signCheckLocation.address || '')
      }
    },
    reLoaction() {
      this.$bus.$emit('callReloacation', null)
    },
    locating(){
      this.locatingStr+='.'
      this.dotNum++
      if(this.dotNum>6){
        this.locatingStr='定位中请稍后'
        this.dotNum=0
      }
    },
    async checkin() {
      if(this.signCheckLocation.lng=='0.00'||this.signCheckLocation.lat=='0.00'){
        this.$toast('请等待定位完成后再进行打卡')
        return false
      }
      const res=await checkinModel.addSignCheckrecords(this.signCheckLocation,null)
      if(res.success){
        this.$toast('打卡成功')
      }else{
        this.$toast(res.msg)
      }
    },
  },
  computed: {
    ...mapState('loacationAbout', ['signCheckLocation']),
    ...mapState('userAbout', ['salesName']),
  },
  watch: {
    // 定位坐标更新时刷新地图
    'signCheckLocation.lat'() {
      this.updateMap()
    },
    'signCheckLocation.lng'() {
      this.updateMap()
    },
  },
  mounted() {
    this.currentTime()
    this.updateMap()
  },
  beforeDestroy() {
    if (this.formatDate) {
      clearInterval(this.formatDate) //清除时间定时器
    }
    if (this.locating) {
      clearInterval(this.formatDate) //清除时间定时器
    }
  },
}
</script>

<style scoped>
.checkin-map {
  width: 100%;
  height: 220px;
  margin: 12px 0;
  border-radius: 8px;
  border: 1px solid #e5e5e5;
  overflow: hidden;
}
</style>